import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

interface IconDefinition {
    name: string;
    path: string;
}

@Injectable({
    providedIn: 'root'
})
export class IconService {
    private registeredIcons = new Set<string>();

    // Social icons with inline SVG
    private readonly socialIcons: { name: string; svg: string }[] = [
        {
            name: 'facebook',
            svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path fill="currentColor" d="M18 2H15C13.6739 2 12.4021 2.52678 11.4645 3.46447C10.5268 4.40215 10 5.67392 10 7V10H7V14H10V22H14V14H17L18 10H14V7C14 6.73478 14.1054 6.48043 14.2929 6.29289C14.4804 6.10536 14.7348 6 15 6H18V2Z"/>
      </svg>`
        },
        {
            name: 'linkedin',
            svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path fill="currentColor" d="M19 3C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H19ZM18.5 18.5V13.2C18.5 12.3354 18.1565 11.5062 17.5452 10.8948C16.9338 10.2835 16.1046 9.94 15.24 9.94C14.39 9.94 13.4 10.46 12.92 11.24V10.13H10.13V18.5H12.92V13.57C12.92 12.8 13.54 12.17 14.31 12.17C14.6813 12.17 15.0374 12.3175 15.2999 12.5801C15.5625 12.8426 15.71 13.1987 15.71 13.57V18.5H18.5ZM6.88 8.56C7.32556 8.56 7.75288 8.383 8.06794 8.06794C8.383 7.75288 8.56 7.32556 8.56 6.88C8.56 6.43444 8.383 6.00712 8.06794 5.69206C7.75288 5.377 7.32556 5.2 6.88 5.2C6.43444 5.2 6.00712 5.377 5.69206 5.69206C5.377 6.00712 5.2 6.43444 5.2 6.88C5.2 7.32556 5.377 7.75288 5.69206 8.06794C6.00712 8.383 6.43444 8.56 6.88 8.56ZM8.27 18.5V10.13H5.5V18.5H8.27Z"/>
      </svg>`
        },
        {
            name: 'instagram',
            svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 359.99999 359.9696">
        <g transform="translate(-77.12909,-99.75057)">
          <path fill="currentColor" d="m 257.12909,129.76098 c -40.73362,0 -45.84008,0.25899 -61.83741,0.91733 -15.96445,0.7292 -26.846,3.22727 -36.38561,6.93669 -9.8635,3.83171 -18.26206,8.98306 -26.60017,17.32165 -8.33835,8.33859 -13.44169,16.69125 -17.27412,26.55409 -3.70877,9.54051 -6.25479,20.46653 -6.98302,36.43098 -0.73154,15.99732 -0.91968,21.10396 -0.91968,61.83716 0,40.73554 0.18808,45.83984 0.91968,61.83717 0.72919,15.96445 3.27425,26.84576 6.98302,36.38633 3.83243,9.86278 8.93577,18.21549 17.27412,26.55403 8.33811,8.33859 16.73667,13.48525 26.60017,17.3193 9.53961,3.70708 20.42116,6.25455 36.38561,6.98374 15.99733,0.7292 21.10379,0.87029 61.83741,0.87029 40.73362,0 45.83984,-0.23496 61.8374,-0.87029 15.96422,-0.72919 26.89185,-3.27666 36.43147,-6.98374 9.8635,-3.83405 18.21621,-8.98071 26.55432,-17.3193 8.33835,-8.33854 13.44145,-16.69125 17.27388,-26.55403 3.70876,-9.54057 6.25503,-20.42188 6.98326,-36.38633 0.73154,-15.99733 0.91968,-21.10163 0.91968,-61.83717 0,-40.7332 -0.18808,-45.83984 -0.91968,-61.83716 -0.7292,-15.96445 -3.2745,-26.89047 -6.98326,-36.43098 -3.83243,-9.86284 -8.93553,-18.2155 -17.27388,-26.55409 -8.33811,-8.33859 -16.69082,-13.48994 -26.55432,-17.32165 -9.53962,-3.70942 -20.46725,-6.20749 -36.43147,-6.93669 -15.99732,-0.72919 -21.10378,-0.91733 -61.8374,-0.91733 z m 0,27.01275 c 40.04775,0 44.78087,0.23495 60.59684,0.87028 14.623,0.65865 22.60141,3.13785 27.88658,5.19137 7.00117,2.72149 11.98006,5.96281 17.22809,11.21061 5.24894,5.24779 8.48978,10.2274 11.20964,17.22754 2.05353,5.28542 4.52401,13.26413 5.19155,27.88544 0.71982,15.81622 0.87269,20.5512 0.87269,60.59757 0,40.04865 -0.16464,44.78369 -0.87269,60.59756 -0.66802,14.62366 -3.13802,22.55533 -5.19155,27.84074 -2.71986,7.00014 -5.9607,12.02211 -11.20964,17.27225 -5.24803,5.2478 -10.22692,8.48912 -17.22809,11.2106 -5.28517,2.04643 -13.26358,4.48099 -27.88658,5.14667 -15.81363,0.72913 -20.54555,0.87028 -60.59684,0.87028 -40.0513,0 -44.78322,-0.23495 -60.59684,-0.87028 -14.62301,-0.65865 -22.55557,-3.09321 -27.84074,-5.14667 -7.0011,-2.72148 -12.0259,-5.9628 -17.27394,-11.2106 -5.24773,-5.25014 -8.48863,-10.27211 -11.20964,-17.27225 -2.05352,-5.28541 -4.47792,-13.21708 -5.14546,-27.84074 -0.71982,-15.81387 -0.87269,-20.54891 -0.87269,-60.59756 0,-40.04637 0.16465,-44.78135 0.87269,-60.59757 0.66803,-14.62131 3.09194,-22.60002 5.14546,-27.88544 2.72101,-7.00014 5.96191,-11.97975 11.20964,-17.22754 5.24804,-5.2478 10.27284,-8.48912 17.27394,-11.21061 5.28517,-2.04643 13.21773,-4.52334 27.84074,-5.19137 15.81597,-0.72913 20.54909,-0.87028 60.59684,-0.87028 z m 80.07621,24.90046 c -9.93951,0 -18.0092,8.06807 -18.0092,18.00848 0,9.94042 8.06969,18.00854 18.0092,18.00854 9.94066,0 18.00896,-8.06812 18.00896,-18.00854 0,-9.94041 -8.0683,-18.00848 -18.00896,-18.00848 z m -80.07621,21.04051 c -42.53614,0 -76.99809,34.50924 -76.99809,77.04418 0,42.53735 34.46195,76.99713 76.99809,76.99713 42.53614,0 77.04394,-34.45978 77.04394,-76.99713 0,-42.53494 -34.5078,-77.04418 -77.04394,-77.04418 z m 0,27.0598 c 27.61161,0 49.98438,22.37415 49.98438,49.98438 0,27.61257 -22.37277,49.98438 -49.98438,49.98438 -27.61161,0 -49.98444,-22.37181 -49.98444,-49.98438 0,-27.61023 22.37283,-49.98438 49.98444,-49.98438 z"/>
        </g>
      </svg>`
        }
    ];

    // File-based icons - add new icons here
    private readonly fileIcons: IconDefinition[] = [
        // Navbar icons
        { name: 'nav-home', path: 'assets/icons/navbar/home.svg' },
        { name: 'nav-calculator', path: 'assets/icons/navbar/calculator.svg' },
        { name: 'nav-suburb', path: 'assets/icons/navbar/suburb-nav.svg' },
        { name: 'nav-pathways', path: 'assets/icons/navbar/pathways.svg' },
        { name: 'nav-compare', path: 'assets/icons/navbar/compare.svg' },
        { name: 'nav-services', path: 'assets/icons/navbar/services.svg' },
        { name: 'nav-ai-assistant', path: 'assets/icons/navbar/ai-assistant.svg' },
        { name: 'nav-profile', path: 'assets/icons/navbar/profile.svg' },

        // General icons
        { name: 'alarm-clock', path: 'assets/icons/alarm-clock.svg' },
        { name: 'currency-dollar-circle', path: 'assets/icons/currency-dollar-circle.svg' },
        { name: 'distance', path: 'assets/icons/distance.svg' },
        { name: 'expert-help', path: 'assets/icons/expert-help.svg' },
        { name: 'house', path: 'assets/icons/house.svg' },
        { name: 'money', path: 'assets/icons/money.svg' },
        { name: 'radar', path: 'assets/icons/radar.svg' },
        { name: 'result', path: 'assets/icons/result.svg' },
        { name: 'ruler', path: 'assets/icons/ruler.svg' },
        { name: 'scores', path: 'assets/icons/scores.svg' },
        { name: 'stock-level', path: 'assets/icons/stock-level.svg' },
        { name: 'target', path: 'assets/icons/target.svg' },
        { name: 'thumbs-down', path: 'assets/icons/thumbs-down.svg' },
        { name: 'thumbs-up', path: 'assets/icons/thumbs-up.svg' },
        { name: 'trend-up', path: 'assets/icons/trend-up.svg' },
    ];

    constructor(
        private iconRegistry: MatIconRegistry,
        private sanitizer: DomSanitizer
    ) { }

    /**
     * Register all icons (social + file-based).
     * Call this once in the app initialization (e.g., AppComponent or root layout).
     */
    registerAllIcons(): void {
        this.registerSocialIcons();
        this.registerFileIcons();
    }

    /**
     * Register only social icons (inline SVG).
     */
    registerSocialIcons(): void {
        for (const icon of this.socialIcons) {
            if (!this.registeredIcons.has(icon.name)) {
                this.iconRegistry.addSvgIconLiteral(
                    icon.name,
                    this.sanitizer.bypassSecurityTrustHtml(icon.svg)
                );
                this.registeredIcons.add(icon.name);
            }
        }
    }

    /**
     * Register only file-based icons.
     */
    registerFileIcons(): void {
        for (const icon of this.fileIcons) {
            if (!this.registeredIcons.has(icon.name)) {
                this.iconRegistry.addSvgIcon(
                    icon.name,
                    this.sanitizer.bypassSecurityTrustResourceUrl(icon.path)
                );
                this.registeredIcons.add(icon.name);
            }
        }
    }

    /**
     * Register a custom icon dynamically.
     * @param name - The name to use with mat-icon svgIcon
     * @param path - The path to the SVG file
     */
    registerIcon(name: string, path: string): void {
        if (!this.registeredIcons.has(name)) {
            this.iconRegistry.addSvgIcon(
                name,
                this.sanitizer.bypassSecurityTrustResourceUrl(path)
            );
            this.registeredIcons.add(name);
        }
    }

    /**
     * Register a custom icon with inline SVG.
     * @param name - The name to use with mat-icon svgIcon
     * @param svg - The SVG markup
     */
    registerIconLiteral(name: string, svg: string): void {
        if (!this.registeredIcons.has(name)) {
            this.iconRegistry.addSvgIconLiteral(
                name,
                this.sanitizer.bypassSecurityTrustHtml(svg)
            );
            this.registeredIcons.add(name);
        }
    }

    /**
     * Check if an icon is already registered.
     */
    isIconRegistered(name: string): boolean {
        return this.registeredIcons.has(name);
    }
}
